import styled from '@emotion/styled';

export const TopContainer = styled('div')((p) => ({
  top: 0,
  position: 'sticky',
  marginBottom: p.theme.spacing(3),
  zIndex: 2,
  boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.1)'
}));
